import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getWithdrawlDetail } from '../../api/sportaloka-client';
import {
  getWithdrawlHistoryContent,
  getWithdrawStatusColor,
  getWithdrawStatusLabel
} from '../../helpers/status';
import { format } from 'date-fns';
import WithdrawlHistory from './components/WithdrawlHistory';

const WithdrawlDetail = () => {
  const { id } = useParams();
  const [initLoading, setInitLoading] = useState();
  const [initError, setInitError] = useState();
  const [data, setData] = useState(null);
  const [histories, setHistories] = useState([]);

  const getData = async () => {
    try {
      setInitError(false);
      setInitLoading(true);
      const response = await getWithdrawlDetail(id);
      const responseData = response.data.data;
      const bookingHistories = responseData.withdrawl_histories.map((item) =>
        getWithdrawlHistoryContent(item)
      );
      setData(responseData);
      setHistories(bookingHistories);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Detail Penarikan Saldo</h1>
          <div className="d-flex">
            <Link to="/withdrawl" className="button -sm px-3 bg-white h-50 text-dark mr-10">
              <i className="fa fa-arrow-left mr-10" />
              Kembali
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <WithdrawlHistory
              data={histories}
              initLoading={initLoading}
              initError={initError}
              retry={getData}
            />
          </div>
          <div className="col-9">
            <div
              className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20"
              style={{ minHeight: 540 }}>
              {initLoading && !initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100"
                  style={{ minHeight: 540 }}>
                  <div className="loader" />
                  <div className="fw-600" style={{ marginLeft: 12 }}>
                    Loading...
                  </div>
                </div>
              )}
              {!initLoading && initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100 text-center"
                  style={{ minHeight: 540 }}>
                  <p className="fw-600">
                    Gagal! Periksa koneksi internet anda dan{' '}
                    <span className="text-danger cursor-pointer" onClick={getData}>
                      Coba lagi
                    </span>
                  </p>
                </div>
              )}
              {!initLoading && !initError && (
                <div>
                  <div>
                    <h5 className="fw-700 text-blue-1 text-18">Informasi Penarikan</h5>
                    <table className="table table-striped mt-20">
                      <tbody>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Tanggal Penarikan
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            {data && format(new Date(data.created_at), 'dd/MM/yyyy HH:MM:ss')}
                          </th>
                        </tr>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Update Terakhir
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            {data && format(new Date(data.updated_at), 'dd/MM/yyyy HH:MM:ss')}
                          </th>
                        </tr>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Jumlah Penarikan
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            IDR {data && data.amount.toLocaleString('id-ID')}
                          </th>
                        </tr>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Fee Penarikan
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            IDR {data && data.fee_amount.toLocaleString('id-ID')}
                          </th>
                        </tr>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Jumlah yang di transfer
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            IDR {data && (data.amount - data.fee_amount).toLocaleString('id-ID')}
                          </th>
                        </tr>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Rekening Bank
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            {data && data.bank
                              ? `${data.bank.bank_name} ${data.bank.account_number} a/n ${data.bank.account_name}`
                              : '-'}
                          </th>
                        </tr>
                        <tr>
                          <td className="px-3 py-2" width="30%">
                            Status
                          </td>
                          <td className="px-3 py-2" width="5%">
                            :
                          </td>
                          <th className="text-right px-3 py-2 text-14">
                            <span
                              className={`px-2 py-1 rounded-1 fw-600 ${data && getWithdrawStatusColor(data.status)}`}>
                              {data && getWithdrawStatusLabel(data.status)}
                            </span>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawlDetail;
